var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll",attrs:{"id":"logistics-display-chart"}},[_c('div',[_c('ApexChart',{attrs:{"type":"bar","height":"350","options":_vm.wpuOptions,"series":_vm.wpuSeries}})],1),_c('div',[_c('ApexChart',{attrs:{"type":"bar","height":"350","options":_vm.wbdOptions,"series":_vm.wbdSeries}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }